import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useReducer, useRef, useImperativeHandle, } from 'react';
import { useFullscreen } from 'react-science/ui';
import { AssignmentProvider } from '../assignment';
import { GlobalProvider } from '../context/GlobalContext';
import { KeyModifiersProvider } from '../context/KeyModifierContext';
import { LoggerProvider } from '../context/LoggerContext';
import { PreferencesProvider } from '../context/PreferencesContext';
import { ToasterProvider } from '../context/ToasterContext';
import { TopicMoleculeProvider } from '../context/TopicMoleculeContext';
import { ModalProvider } from '../elements/popup/Modal';
import { HighlightProvider } from '../highlight';
import { defaultGetSpinner, SpinnerProvider } from '../loader/SpinnerContext';
import preferencesReducer, { preferencesInitialState, initPreferencesState, readSettings, } from '../reducer/preferences/preferencesReducer';
import { getBlob } from '../utility/export';
import { InnerNMRiumContents } from './InnerNMRiumContents';
import NMRiumStateProvider from './NMRiumStateProvider';
export function InnerNMRium({ data: nmriumData, workspace, customWorkspaces, preferences, getSpinner = defaultGetSpinner, onChange, emptyText, innerRef, }) {
    const rootRef = useRef(null);
    const elementsWrapperRef = useRef(null);
    const viewerRef = useRef(null);
    const mainDivRef = useRef(null);
    const { isFullScreen } = useFullscreen();
    const [preferencesState, dispatchPreferences] = useReducer(preferencesReducer, preferencesInitialState, initPreferencesState);
    useEffect(() => {
        rootRef.current?.focus();
    }, [isFullScreen]);
    useEffect(() => {
        const settings = readSettings();
        dispatchPreferences({
            type: 'INIT_PREFERENCES',
            payload: {
                preferences,
                workspace,
                customWorkspaces,
                currentWorkspace: settings?.currentWorkspace,
                dispatch: dispatchPreferences,
            },
        });
    }, [customWorkspaces, preferences, workspace]);
    useImperativeHandle(innerRef, () => ({
        getSpectraViewerAsBlob: () => {
            return rootRef?.current ? getBlob(rootRef.current, 'nmrSVG') : null;
        },
    }), []);
    return (_jsx("div", { ref: mainDivRef, style: { height: '100%', position: 'relative' }, translate: "no", children: _jsx(GlobalProvider, { value: {
                rootRef: rootRef.current,
                elementsWrapperRef: elementsWrapperRef.current,
                viewerRef: viewerRef.current,
            }, children: _jsx(PreferencesProvider, { value: preferencesState, children: _jsx(LoggerProvider, { children: _jsx(KeyModifiersProvider, { children: _jsx(ToasterProvider, { children: _jsx(NMRiumStateProvider, { onChange: onChange, nmriumData: nmriumData, children: _jsx(TopicMoleculeProvider, { children: _jsx(ModalProvider, { wrapperRef: elementsWrapperRef.current, children: _jsx(HighlightProvider, { children: _jsx(AssignmentProvider, { children: _jsx(SpinnerProvider, { value: getSpinner, children: _jsx(InnerNMRiumContents, { emptyText: emptyText, mainDivRef: mainDivRef, elementsWrapperRef: elementsWrapperRef, rootRef: rootRef, viewerRef: viewerRef }) }) }) }) }) }) }) }) }) }) }) }) }));
}
